<template>
  <a-modal
    v-model:open="visible"
    title="快递信息"
    centered
    wrapClassName="emsModal"
    :footer="null"
    :afterClose="hiddenModal"
    :bodyStyle="{ maxHeight: '700px', overflow: 'auto' }"
  >
    <a-spin :spinning="spinning">
      <p>快递：{{ item.ems }}</p>
      <p>快递单号：{{ item.emsid || item.ems_id }}</p>
      <p>发货时间：{{ ship_time }}</p>
      <template v-if="emsInfoList.length > 0">
        <p>详细物流信息：</p>
        <a-timeline :reverse="true">
          <a-timeline-item v-for="(infoItem, index) in emsInfoList" :key="index" :color="index === emsInfoList.length - 1 ? '#ED4014' : 'blue'">
            <div class="timeline-content" :style="{ color: index === emsInfoList.length - 1 ? '#ED4014' : '#758697' }">
              <p>{{ infoItem.AcceptTime }}</p>
              <p>{{ infoItem.AcceptStation }}</p>
            </div>
          </a-timeline-item>
        </a-timeline>
      </template>
      <p style="color: #999999" v-else>该单号暂无物流进展</p>
      <p>注：快递详情可在百度上输入快递单号查询</p>
    </a-spin>
  </a-modal>
</template>

<script>
  export default {
    name: 'EhfEmsInfo',
  }
</script>

<script setup>
  import { getEmsInfo } from '@/api/common/index'
  import { ref, toRefs, computed } from 'vue'

  const props = defineProps({
    show: {
      type: Boolean,
      default() {
        return false
      },
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  })
  const { show, item } = toRefs(props)
  const emit = defineEmits(['update:show'])

  const visible = ref(false) // 控制弹窗显示
  visible.value = show.value // 默认使用传入的show
  const spinning = ref(false) // 数据加载loading
  const emsInfoList = ref([]) // 物流信息列表
  const ship_time = computed(() => {
    if (item.value.ship_time) {
      // 优先使用传入的发货时间
      return item.value.ship_time
    } else if (emsInfoList.value.length > 0) {
      // 否则使用物流第一条的时间
      return emsInfoList.value[0].AcceptTime
    } else {
      // 否则不显示
      return ''
    }
  }) // 发货时间

  // 获取物流信息
  const getInfo = async () => {
    spinning.value = true
    const body = {
      ems: item.value.ems,
      emsid: item.value.emsid || item.value.ems_id,
      customer: item.value.mobile.substr(-4),
    }
    const res = await getEmsInfo(body)
    spinning.value = false
    if (res && res.Success) {
      emsInfoList.value = res.Traces
    } else {
      emsInfoList.value = []
    }
  }
  // 隐藏弹窗
  const hiddenModal = () => {
    emit('update:show', false)
  }

  getInfo()
</script>

<style lang="scss" scoped>
  .emsModal {
    color: #758697;
    .timeline-content {
      p {
        margin-bottom: 0;
      }
    }
  }
</style>
